import { OrganisationFormat } from '../types/organisation'

export const itemWord = (format?: OrganisationFormat): string => {
  const itemWordingMap = new Map<OrganisationFormat, string>([
    [OrganisationFormat.GiftVouchers, 'gift'],
    [OrganisationFormat.SpecialOffers, 'offer'],
    [OrganisationFormat.Tickets, 'ticket'],
  ])

  if (format) {
    const wording = itemWordingMap.get(format)
    if (wording) return wording
  }
  return 'item'
}

export const voucherWord = (format?: OrganisationFormat): string => {
  const voucherWordingMap = new Map<OrganisationFormat, string>([
    [OrganisationFormat.GiftVouchers, 'gift voucher'],
    [OrganisationFormat.SpecialOffers, 'special offer voucher'],
    [OrganisationFormat.Tickets, 'ticket'],
  ])

  if (format) {
    const wording = voucherWordingMap.get(format)
    if (wording) return wording
  }
  return 'voucher'
}

export const organisationWord = (format?: OrganisationFormat): string => {
  const organisationWordingMap = new Map<OrganisationFormat, string>([
    [OrganisationFormat.GiftVouchers, 'gift'],
    [OrganisationFormat.SpecialOffers, 'special offer'],
    [OrganisationFormat.Tickets, 'ticket'],
  ])
  if (format) {
    const wording = organisationWordingMap.get(format)
    if (wording) return wording
  }
  return 'organisation'
}

export const shortVoucherWord = (format?: OrganisationFormat): string => {
  const shortVoucherWordingMap = new Map<OrganisationFormat, string>([
    [OrganisationFormat.GiftVouchers, 'voucher'],
    [OrganisationFormat.SpecialOffers, 'voucher'],
    [OrganisationFormat.Tickets, 'ticket'],
  ])
  if (format) {
    const wording = shortVoucherWordingMap.get(format)
    if (wording) return wording
  }
  return 'voucher'
}
